import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import summaryCashTotalMultiStyles from './summaryCashTotalMultiStyles';
import Price from '../../../../../../../gqlCommon/components/presentation/Price';
import IPrice from '../../../../../../../gqlCommon/model/prices/IPrice';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';

export interface ISummaryCashTotalProps {
  primaryTotal: IPrice;
  classes?: {
    price?: string;
  };
}

const SummaryCashTotalMulti: FC<ISummaryCashTotalProps> = ({ primaryTotal, classes }) => {
  const { total, price, inlinePrice } = summaryCashTotalMultiStyles();

  return (
    <Typography color="textSecondary" variant="h4" className={clsx([total, price])} data-test="text:total:price">
      <Price
        component="span"
        className={clsx([inlinePrice, classes?.price])}
        // price={ getPrimaryBasePrice(primaryTotal?.amount, partExchangeValue) }
        price={primaryTotal?.money.amount}
        currency={primaryTotal?.money.currency}
        data-test="text:price:primary_currency_value"
        priceDisplayType={PriceDisplayType.PRIMARY}
      />
    </Typography>
  );
};

export default SummaryCashTotalMulti;
